'use client'
import React from 'react'
import styles from './styles.module.scss'

interface ButtonProps {
  type: 'minus' | 'plus'
  onClick: (type) => void
  disabled?: boolean
}

const Button: React.FC<ButtonProps> = ({ type, onClick, disabled = false }) => (
  <div
    className={styles.button}
    onClick={() => {
      if (disabled) return
      onClick(type)
    }}
  >
    {type === 'minus' ? (
      <>
        {/* eslint-disable-next-line */}
        <img src="/img/icons/amount/minus.svg" alt={type} />
      </>
    ) : (
      <>
        {/* eslint-disable-next-line */}
        <img src="/img/icons/amount/plus.svg" alt={type} />
      </>
    )}
  </div>
)

export default Button
